/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Meta_TitleInputs */

const es_faq_meta_title = /** @type {(inputs: Faq_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes | Alquiler de barcos | Zarpar`)
};

const gl_faq_meta_title = /** @type {(inputs: Faq_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes | Alugueiro de barcos | Zarpar`)
};

const en_faq_meta_title = /** @type {(inputs: Faq_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ | Boat rental | Zarpar`)
};

/**
* | output |
* | --- |
* | "FAQ \| Boat rental \| Zarpar" |
*
* @param {Faq_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_meta_title = /** @type {((inputs?: Faq_Meta_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Meta_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_meta_title(inputs)
	if (locale === "en") return en_faq_meta_title(inputs)
	return es_faq_meta_title(inputs)
});